import { render } from "./IPAside.vue?vue&type=template&id=4f01feda"
import script from "./IPAside.vue?vue&type=script&lang=js"
export * from "./IPAside.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__